module.exports = __webpack_public_path__ + "static/img/pendant.9308c57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/pendant.png
// module id = GPiI
// module chunks = 215